import React from "react";
import CardContent from "../../components/CardContent/CardContent";
import { ImageRatios } from "../../components/Image/Image";
import ImageCard from "../../components/ImageCard/ImageCard";
import { SanityDocument } from "../../model/common";
import { urlForDocument } from "../../urls";

interface GenericDocument extends SanityDocument {
  title: string;
  description: string;
}

interface CreativeProjectCardProps {
  className?: string;
  document: GenericDocument;
}

const CreativeProjectCard = ({
  className,
  document
}: CreativeProjectCardProps) => {
  const url = urlForDocument(document);
  const d = document as any;
  const image = d.image;
  const { title, description } = document;
  return (
    <ImageCard
      widths={324}
      className={className}
      image={image}
      aspectRatio={ImageRatios.Landscape_4_3}
      padded={document._type === "unitOfWork"}
      href={url}
    >
      <CardContent title={title} text={description} href={url} readMore />
    </ImageCard>
  );
};

export default CreativeProjectCard;
